const INTERVAL_FOR_CHECK_API = 10000;

export default INTERVAL_FOR_CHECK_API;
